import React from 'react';
import { Radio, Space } from 'antd';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import { RadioBtn } from '../SettingsOverlay/SettingsOverlay.styles';
import { useLanguage } from '@app/hooks/useLanguage';
import { languageOptions } from '@app/constants/languageOptions';

export const LanguagePicker: React.FC = () => {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();

  return (
    <Radio.Group
      defaultValue={language}
      onChange={(e) => setLanguage(e.target.value)}
    >
      <Space direction="vertical">
        {languageOptions.map((lang) => (
          <RadioBtn key={lang.key} value={lang.key}>
            <Space align="center">
              {t(lang.labelKey)}
              <ReactCountryFlag svg countryCode={lang.countryCode} />
            </Space>
          </RadioBtn>
        ))}
      </Space>
    </Radio.Group>
  );
};
